import { render, staticRenderFns } from "./ConfirmSubmitDialog.vue?vue&type=template&id=e219c3ca&scoped=true&"
import script from "./ConfirmSubmitDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmSubmitDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmSubmitDialog.vue?vue&type=style&index=0&id=e219c3ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e219c3ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
